import React, { useState } from 'react';

function MerkleTree({ merkleTree, txID }) {
  const [expanded, setExpanded] = useState(false);

  if (!merkleTree || !merkleTree.levels || merkleTree.levels.length === 0) return null;

  const { path, root, txCount, treeHeight, computedRoot, actualBlockHash } = merkleTree;
  const displayRoot = computedRoot || root;
  const rootMatches = displayRoot === actualBlockHash;
  const short = (h) => h ? `${h.substring(0, 10)}...${h.substring(h.length - 8)}` : 'N/A';

  return (
    <div style={{
      border: '1px solid #e8e8e8',
      borderRadius: '6px',
      overflow: 'hidden',
      fontSize: '0.8rem'
    }}>
      {/* Summary row */}
      <div
        onClick={() => setExpanded(!expanded)}
        style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '8px 12px', background: '#f5f5f5',
          cursor: 'pointer', userSelect: 'none',
          borderBottom: expanded ? '1px solid #e8e8e8' : 'none'
        }}
      >
        <span style={{ color: '#444', fontWeight: '600' }}>
          In-Block Merkle Tree &nbsp;
          <span style={{ fontWeight: '400', color: '#666' }}>
            {txCount} tx · {treeHeight} level{treeHeight !== 1 ? 's' : ''} · {path.length} proof step{path.length !== 1 ? 's' : ''}
            {actualBlockHash && (
              <span style={{ marginLeft: '8px', color: rootMatches ? '#276749' : '#c53030' }}>
                · root {rootMatches ? 'matches' : 'mismatch'}
              </span>
            )}
          </span>
        </span>
        <span style={{ color: '#888' }}>{expanded ? 'Collapse' : 'Expand'}</span>
      </div>

      {expanded && (
        <div style={{ padding: '10px 12px' }}>
          {/* Proof path steps */}
          {path.length > 0 && (
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '10px' }}>
              <thead>
                <tr style={{ background: '#f9f9f9' }}>
                  <th style={{ padding: '4px 8px', textAlign: 'left', color: '#555', fontWeight: '600' }}>Step</th>
                  <th style={{ padding: '4px 8px', textAlign: 'left', color: '#555', fontWeight: '600' }}>Side</th>
                  <th style={{ padding: '4px 8px', textAlign: 'left', color: '#555', fontWeight: '600' }}>Sibling Hash</th>
                </tr>
              </thead>
              <tbody>
                {path.map((step, i) => (
                  <tr key={i} style={{ borderTop: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '4px 8px', color: '#333' }}>{i + 1}</td>
                    <td style={{ padding: '4px 8px', color: '#333', textTransform: 'uppercase', fontSize: '0.74rem' }}>{step.position}</td>
                    <td style={{ padding: '4px 8px', fontFamily: 'monospace', color: '#555' }}>{short(step.hash)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* Root hashes */}
          <div style={{ fontSize: '0.76rem', color: '#666' }}>
            <div><strong>Computed root:</strong> <span style={{ fontFamily: 'monospace' }}>{short(displayRoot)}</span></div>
            {actualBlockHash && (
              <div style={{ marginTop: '2px' }}>
                <strong>Block data hash:</strong>{' '}
                <span style={{ fontFamily: 'monospace' }}>{short(actualBlockHash)}</span>
                {' '}<span style={{ color: rootMatches ? '#276749' : '#c53030' }}>
                  ({rootMatches ? 'match' : 'mismatch — Fabric uses protobuf serialization'})
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default MerkleTree;
